import type { ConfidenceOptions } from '@spotify-confidence/sdk';

export const FLAG_RESOLVER_PROXY_BASE_URL = '/api/flag-resolver';

type FlagResolverProxyOptions = Pick<
  ConfidenceOptions,
  'resolveBaseUrl' | 'applyBaseUrl'
>;

export const getFlagResolverProxyOptions = (
  nodeEnvironment: string | undefined,
  origin: string,
): FlagResolverProxyOptions | Record<string, never> =>
  nodeEnvironment === 'production'
    ? {
        resolveBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
        applyBaseUrl: `${origin}${FLAG_RESOLVER_PROXY_BASE_URL}`,
      }
    : {};
